import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './style.scss';
import { pluralize, formatNumber } from 'utils';
import { addToFavorites, removeFromFavorites } from 'actions/favorites';
import { setPopUp } from 'actions/environment';

import { ROOT_URL } from 'constants/Config.js';

import CollectionsDialog from 'components/Building/Main/CollectionsDialog';

import iconClose from 'assets/images/icons/icon-close.svg';
import iconHeart from 'assets/images/icons/icon-heart.svg';
import iconHeartActive from 'assets/images/icons/icon-heart-active-blue.svg';
import placeholder from 'assets/images/banner-placeholder.jpg';
import cn from 'classnames';
import tracker from '../../../../services/tracker';
import { withTranslation } from 'react-i18next';

let cx = cn.bind(styles);

const addDefaultSrc = (ev) => {
  ev.target.src = placeholder;
};

class PlaceInfo extends Component {

  handleAddToCollectionClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { point } = this.props;
    const {
      id: buildingId,
      title: buildingName
    } = point;

    tracker.sendEvent('Web_Add_To_Collection', {
      id: buildingId,
      name: buildingName,
      mode: 'map'
    });

    this.props.setPopUp(
      <CollectionsDialog building={{ data: this.props.point }} />,
      {
        // closeClassName: styles.popupClose,
        closeStyleName: 'Default',
        contentStyleName: 'Default',
        closeIcon: 'default',
        lockScroll: false
      }
    );
  }

  handleAddToFavoritesClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const { point } = this.props;
    const {
      id: buildingId,
      title: buildingName,
      favorite
    } = point;
    const userUid = localStorage.getItem('public');

    tracker.sendEvent(favorite ? 'Web_Remove_From_Favorites' : 'Web_Add_To_Favorites', {
      id: buildingId,
      name: buildingName,
      mode: 'map'
    });

    this.props[favorite ? 'removeFromFavorites' : 'addToFavorites'](
      { buildingId, userUid },
      { buildingName, data: this.props }
    );
  }

  handleClick = () => {
    const { point } = this.props;
    const {
      id: buildingId,
      title: buildingName
    } = point;

    tracker.sendEvent('Web_Click', {
      id: buildingId,
      name: buildingName,
      mode: 'map'
    });
  }

  render() {
    const { point, style, infoType } = this.props;

    if (!point) {
      return (
        <div style={style} className={styles.PlaceInfo}>
          <div className={styles.Loader} />
        </div>
      );
    }

    const { onClose, t } = this.props;

    const {
      title,
      address,
      microregion,
      favorite,
      image,
      count_flats: flatsCount,
      cost_min: costMin,
      min_area_cost: minAreaCost,
      min_square: minSquare,
      max_square: maxSquare,
      construction_ending,
      construction_finished,
      year_built,
      checkout,
      checkout2,
      status,
      view_action,
      type_id
    } = point;

    return (
      <a
        style={style}
        onClick={this.handleClick}
        className={cx(styles.PlaceInfo, (infoType === 'medium') ? styles.Medium : null)}
        href={infoType !== 'medium' ? `/building/${point.id}` : `/view/${location.href.replace(/.*\//, '')}/building/${point.id}`}
        target="_blank"
      >
        <div className={cn(styles.Header, { [styles.WithoutPhoto]: !image })}>
          {image ? (<img alt="house" className={styles.Image} onError={addDefaultSrc} src={`${ROOT_URL}/image?id=${image.id}&size=small`} />) : null}
          <div>
            <h1>{title}</h1>
            <h3>{`${microregion}, ${address}`}</h3>
            <div>
              {view_action ? <span className={styles.PromoLabel}>{t('components.common.yPlaceInfo.promo')}</span> : null}
              {status == 3 ? (
                <span className={styles.AlmostFinished}>
                  {t('components.common.yPlaceInfo.almostFinished')}
                </span>
              ) : (
                <span className={construction_finished ? styles.StatusTitle : styles.StatusTitleNotFin}>
                  {construction_finished ? t('components.common.yPlaceInfo.finished') : (year_built !== 0 ? ` ${construction_ending} / ${year_built !== '0' ? year_built : ''}` : t('components.common.yPlaceInfo.inProgress'))}
                </span>
              )}
            </div>
          </div>
          <img src={iconClose} alt="" onClick={onClose} className={styles.IconButton} />
        </div>
        {
          infoType !== 'medium' &&
          <div className={styles.InfoBlock}>
            {checkout2 ? <p className={styles.BlockItem}>{checkout2}</p> : null}
            {checkout ? <p className={styles.BlockItem}>{checkout}</p> : null}

            {/* {military_ipoteka ? <p className={styles.BlockItem}>{`Воен. Ипотека`}</p> : null} */}
            {/* {mat_capital ? <p className={styles.BlockItem}>{`Мат. капитал`}</p> : null} */}
            {/* {ipoteka ? <p className={styles.BlockItem}>{`Ипотека`}</p> : null} */}
            {/* {installments ? <p className={styles.BlockItem}>{`Рассрочка`}</p> : null} */}
          </div>
        }
        { (flatsCount) ? (
          <div className={styles.Flats}>
            {/* <div className={styles.forYourRequest}> */}
            {/* <p>Под ваш запрос</p> */}
            {/* <p className={styles.Blue}>10 квартир</p> */}
            {/* </div> */}
            { status === 2 ? (
              <div className={styles.Stopped}>
                {t('components.common.yPlaceInfo.promo')}
              </div>
            ) : (
              <div>
                {(infoType == 'medium') ? (
                  <div className={styles.FlatsCount}>
                    <p> {flatsCount} {pluralize(flatsCount, t('components.common.yPlaceInfo.flat1'), t('components.common.yPlaceInfo.flat2'), t('components.common.yPlaceInfo.flat3'))}</p>
                  </div>
                ) : (
                  <div>
                    <p> {flatsCount} {pluralize(flatsCount, t('components.common.yPlaceInfo.flat1'), t('components.common.yPlaceInfo.flat2'), t('components.common.yPlaceInfo.flat3'))}</p>
                    <p> {t('components.common.yPlaceInfo.square', { minSquare, maxSquare })}</p>
                  </div>
                )}
              </div>
            )
            }
            {(infoType == 'medium') ? (
              <div className={styles.FlatsPrices}>
                <p> {`${t('components.common.yPlaceInfo.costMin', { costMin: formatNumber(costMin) })}, ${t('components.common.yPlaceInfo.minAreaCost', { minAreaCost: formatNumber(minAreaCost) })}`}</p>
              </div>
            ) : (
              <div>
                <p>
                  {t('components.common.yPlaceInfo.costMin', { costMin: formatNumber(costMin) })}
                </p>
                <p>
                  {t('components.common.yPlaceInfo.minAreaCost', { minAreaCost: formatNumber(minAreaCost) })}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className={cn(styles.Flats, styles.SoldOut)}>
            { status === 2
              ? t('components.common.yPlaceInfo.stopped')
              : (type_id == 2 ? t('components.common.yPlaceInfo.soldHouses') : t('components.common.yPlaceInfo.soldFlats'))
            }
          </div>
        )
        }
        {
          infoType !== 'medium' &&
          <div className={styles.Buttons}>
            <div className={cn(styles.Button, styles.Favorites)} onClick={this.handleAddToFavoritesClick}>
              <img src={favorite ? iconHeartActive : iconHeart} alt="" />
              { favorite ? t('components.common.yPlaceInfo.inFavorite') : t('components.common.yPlaceInfo.addToFavorite')}
            </div>
            <div className={cn(styles.Button, styles.Collections)} onClick={this.handleAddToCollectionClick}>
              <span className={styles.iconPlus}><i></i><i></i></span>
              {t('components.common.yPlaceInfo.addToCollection')}
            </div>
          </div>
        }
      </a>
    );
  }
}

export default connect(null, { setPopUp, addToFavorites, removeFromFavorites })(withTranslation()(PlaceInfo));



// WEBPACK FOOTER //
// ./src/components/common/YMap/YPlaceInfo/index.js